import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "./globalReducer";

const store = configureStore({
  reducer: {
    global: globalReducer,
  },
});

export default store;
